import SidebarBookingsMessagesRoute from 'uplisting-frontend/pods/-sidebar/bookings/messages/route';

export default class ProtectionOverviewBookingsMessagesRoute extends SidebarBookingsMessagesRoute {
  parentRoute = 'protection.overview.bookings';
}
